<template>
  <div>
    <b-row>
      <b-alert :show="statusMessage != null" >
        <p v-html="statusMessage" />
      </b-alert>
    </b-row>
    <b-row style="padding-bottom: 30px">
      <b-col v-if="isAdminOrSuperUser">
        <vSelect
            :dynamicWidth="true"
            :options="getCompanies"
            label="name"
            v-model="company"
            :reduce="(company) => company.id"
            :placeholder="$t('createShipment.placeholder.Choose Company')"
            name="companyDropdown"
            :clearable="false"
            @input="updateList"
            class="useraccount-dropdown"
        />  
      </b-col>
      <b-col>
        <b-form-file
            v-model="file"
            :state="Boolean(file)"
            placeholder="Choose a file or drop it here..."
            drop-placeholder="Drop file here..."
        ></b-form-file>  
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-button :disabled="file == null" @click="upload">Upload</b-button>
      </b-col>
      <b-col>
        <b-button @click="downloadTemplate">Download Template</b-button>
      </b-col>
    </b-row>
    <b-row>
      <b-table striped hover :fields="fields" :items="items">
        <!-- Optional default data cell scoped slot -->
        <template #cell()="data">
          <i>{{ data.value }}</i>
        </template>
        <template v-slot:cell(actions)="data">
          <b-dropdown text="Actions">
            <b-dropdown-item  v-if="isCreated(items[data.index])" @click="processFile(items[data.index])">
              Create Shipments
            </b-dropdown-item>
            <b-dropdown-item v-if="isErrored(items[data.index])" @click="goToErroredShipments(items[data.index])">
              Show Errored Shipments
            </b-dropdown-item>
            <b-dropdown-item v-if="isErrored(items[data.index])" @click="remainingShipmentsShotFile(items[data.index])">
              Download Remaining Shipments
            </b-dropdown-item>
          </b-dropdown>
        </template>
      </b-table>
    </b-row>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';  
import {ACTIONS, CORE_PREFIX} from "@/store/constants";
import historyAction from "@/components/History/historyActions.vue";
import { yoyoHttp } from '@/services/http.service';
import VSelect from "@/components/vSelect.vue";
import 'vue-select/dist/vue-select.css';
export default {
  components: {VSelect, historyAction},
  data() {
    return {
      statusMessage: null,
      file: null,
      shotFileName: '',
      company: null,
      fields: [
        { key: 'registeredAt', label: 'Registered At', sortable: true },
        { key: 'name', label: 'Name', sortable: true },
        { key: "status", label: "Status", sortable: false},  
        { key: 'actions', label: 'Actions' }
      ],
      items: [
      ]
    };
  },
  async mounted() {
    await this.$store.dispatch(CORE_PREFIX + ACTIONS.CORE.INITIALIZE_CREATE_SHIPMENT);
    await this.fetchShotFiles();
    this.$store.dispatch(CORE_PREFIX + ACTIONS.CORE.SET_LOADING, false);
  },
  computed: {
      ...mapGetters('core', ['getCompanies', 'isAdminOrSuperUser']),
  },
  methods: {
    updateList(){
      this.fetchShotFiles();
    },
    isCreated(item){
      //return true;
      return item.status === 'Uploaded' || item.status === null;
    },
    isErrored(item){
      if (!this.isCreated(item) && !this.isProcessing(item)){
        return true;
      }
    },
    
    isProcessing(item){
      return item.status === 'Processing';
    },
    
    goToErroredShipments(item){
      this.$router.push({ name: 'shotFileShipments', query: { id: item.id } });
    },
    
    async remainingShipmentsShotFile(item){
      let id = item.id;
      yoyoHttp.get('api/ShotFile/RemainingShipments/' + id).then((response) => {
        //Download response.data as a csv file
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'remaining_shipments.csv');
        link.click();
      }).catch((error) => {
        console.error(error);
      });
    },
    
    async processFile(item){
      let id = item.id;
      //after 10 seconds, clear the status message
      this.statusMessage = "Processing... wait for a moment."
      setTimeout(() => {
        this.statusMessage = null;
      }, 10000);
      yoyoHttp.get('api/ShotFile/ProcessShotFile/' + id).then((response) => {
        this.statusMessage = response.data;
        //after 10 seconds, clear the status message only if it is not an error
        
        let isError = response.data.contains('Errors:');
        console.error('isError', isError);
        
        if (!response.data.contains('Errors:')) {
          setTimeout(() => {
            this.statusMessage = null;
          }, 10000);
          this.fetchShotFiles();
        }
      }).catch((error) => {
        console.error(error);
      });
    },
    
    async downloadTemplate(){
      yoyoHttp.get('api/ShotFile/DownloadTemplate').then((response) => {
        //Download response.data as a csv file
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'template.csv');
        link.click();
      }).catch((error) => {
        console.error(error);
      });
    },
    
    async fetchShotFiles(){
      this.items = [];
      let self = this;
      let url = '/api/ShotFile/List';
      if (this.company){
        url += '?companyId=' + this.company;
      }
      yoyoHttp.get(url).then((response) => {
        self.items = response.data;
      }).catch((error) => {
        console.error(error);
      });
    },
    async upload(){
      let formData = new FormData();
      formData.append('file', this.file);
      let url = '/api/ShotFile/Upload';
      if (this.company){
        url += '?companyId=' + this.company;
      }
      yoyoHttp.post(url, formData).then((response) => {
        this.statusMessage = response.data;
        let isError = response.data.contains('Errors:');
        console.error('isError', isError);

        if (!response.data.contains('Errors:')) {
          setTimeout(() => {
            this.statusMessage = null;
          }, 10000);
          this.fetchShotFiles();
        }
      }).catch((error) => {
        console.error(error);
      });
    }
  }
};
</script>
<style scoped>
</style>
